// Authoritative ability catalog. Backend deducts costs and enforces cooldowns.

export type AbilityDef = {
  id: string;
  name: string;
  cost: bigint;
  cooldownMs: number;
  unlockBakerLevel: number;
  specLocked?: string;
  durationMs: number;
  description: string;
};

export const ABILITIES: Record<string, AbilityDef> = {
  click_frenzy: { id: "click_frenzy", name: "Click Frenzy", cost: 400n, cooldownMs: 120_000, unlockBakerLevel: 2, specLocked: "baker", durationMs: 30_000, description: "Your clicks are worth 2x for 30s." },
  auto_boost: { id: "auto_boost", name: "Oven Surge", cost: 600n, cooldownMs: 180_000, unlockBakerLevel: 3, specLocked: "automation", durationMs: 60_000, description: "Your automation produces 2x for 60s." },
  golden_luck: { id: "golden_luck", name: "Golden Luck", cost: 800n, cooldownMs: 300_000, unlockBakerLevel: 4, specLocked: "fortune", durationMs: 10_000, description: "Conjures a golden cookie right now." },
  rush_extend: { id: "rush_extend", name: "Rally Rush", cost: 1000n, cooldownMs: 420_000, unlockBakerLevel: 5, specLocked: "coordinator", durationMs: 20_000, description: "Extends an active Cookie Rush by 20s (or starts a 20s rush)." },
  emergency_bake: { id: "emergency_bake", name: "Emergency Bake", cost: 500n, cooldownMs: 300_000, unlockBakerLevel: 2, specLocked: "engineer", durationMs: 0, description: "Instantly bake 60s of bakery production plus a click-power batch." },
};


